import React from 'react';
import { Control, UseControllerProps, useController } from 'react-hook-form';
import StyledInput from '@common/components/FormElements/styled/StyledInput';
import { FieldBlock } from '@common/components/FormElements/BlockInputField/BlockInputField.styles';
import InputWrapper from '@common/components/FormElements/styled/FieldWrapper';
import { Label } from '@common/components/Typography';
import { PersonalizationFormValues } from '../types';

export function Field({
  name,
  label,
  control,
  noAssistive = false,
  ...props
}: {
  name: UseControllerProps<PersonalizationFormValues>['name'];
  label?: string;
  noAssistive?: boolean;
  control: Control<PersonalizationFormValues>;
} & React.ComponentProps<'input'>) {
  const {
    field: { value, ...other },
  } = useController({
    name,
    control,
  });

  return (
    <FieldBlock noAssistive={noAssistive}>
      <InputWrapper>
        {label && <Label htmlFor={name}>{label}</Label>}
        <StyledInput {...other} {...props} value={value || ''} />
      </InputWrapper>
    </FieldBlock>
  );
}
